import * as React from 'react';
import { Select } from 'antd';
import { SelectProps } from 'antd/es/select';

export const Purchasing = (props: SelectProps) => {
    const purchasing_type_options = ['End User', 'Broker'];

    const options = purchasing_type_options.map((o, index) => {
        return (
            <Select.Option key={index} value={o}>
                {o}
            </Select.Option>
        );
    });

    return (
        <Select
            showSearch
            optionFilterProp="children"
            dropdownMatchSelectWidth={false}
            filterOption={(input, option: any) =>
                option?.props?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            {...props}
        >
            {options}
        </Select>
    );
};
